import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import { supabase } from "../../utils/supabaseClient"
import Layout from '../../components/Layouts/businessLayout'
import AlertTemplate from '../../components/Notification'
import { transitions, useAlert, positions, Provider as AlertProvider } from 'react-alert'
import { useAuth, AuthProvider } from '../../contexts/Auth'
import { cloudfront } from "../../config"
import Image from "next/image"
import { uploadPhoto } from "../../components/utils"

export default function Onboarding() {
    const [subPage, setSubPage] = useState(0)
    const [profile, setProfile] = useState(null)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [picLoading, setPicLoading] = useState(false)
    const alert = useAlert()
    const [selected, setSelected] = useState(null)
    const [listing, setListing] = useState({
        education:"",
        pitch:"",
        niche:"",
        info:""
    })
    const [billing, setBilling] = useState({
        monthly_lead_limit: 0,
        credit_card: ""
    })
    const router = useRouter()
    const {user} = useAuth()

    const handleChange = (e) => {
        let newlisting = {...listing}
        newlisting[e.target.name] = e.target.value
        setListing(newlisting)
    }
    const handleBillingChange = (e) => {
        let newBilling = {...billing}
        newBilling[e.target.name] = e.target.value 
        setBilling(newBilling)
    }

    const next = async () => {
        if (subPage === 0) {
            await submitListing()
        } else if (subPage === 1) {
            if (!selected) {
                alert.error("No pricing model selected")
                return
            }
            await submitPricing()
            if (selected === "percentage") {
                router.push("/dashboard")
                return
            } 
        } 
        if (subPage === 2) {
            await submitLeadLimit()
            router.push("/dashboard")
            return
        }

        setSubPage(subPage + 1)
    }

    const uploadImage = async (e, type) => {
        let obj
        let filePath = ""
        setPicLoading(true)
        filePath = await uploadPhoto(e, profile.name)
        const { data, error } = await supabase.from("main_profile").update({ user_image: filePath }).match({ user_id: user.id })

        let newProf ={...profile}
        newProf.user_image = filePath
        setProfile(newProf)

        setPicLoading(false)
    }


    const submitLeadLimit = async () => {
        setLoading(true)

        const {data, error} = await supabase
            .from("main_listing")
            .update({
               monthly_lead_limit: billing.monthly_lead_limit
            })
            .match({ 
                id: listing.id
            })

        error && console.log(error)
        // const {data, error} = await supabase
        // .from("main_listing")
        // .update({

        // })
        // .match({ })
        setLoading(false)
    }


    const submitPricing = async () => {
        setLoading(true)

        const {data, error} = await supabase
            .from("main_listing")
            .update({
                type:selected
            })
            .match({ 
                id: listing.id
            })

        error && console.log(error)
        // const {data, error} = await supabase
        // .from("main_listing")
        // .update({

        // })
        // .match({ })
        setLoading(false)
    }



    const submitListing = async () => {
        setLoading(true)
   
        //submit data
        const {data, error} = await supabase
            .from("main_listing")
            .insert(listing)
    
        error && console.log(error)
        //get id and add to profile
        console.log(data[0])
        setListing(data[0])

        const prof = await supabase
            .from("main_profile")
            .update({listing_id: data[0].id})
            .match({user_id: user.id})

        prof.error && console.log(prof.error)
        setLoading(false)
        
    }

    useEffect(() => {
        const getProfile = async () => {
            const {data, error} = await supabase
                .from("main_profile")
                .select("id, name, user_id, user_image, listing_id(id,type)")
                .match({user_id: user.id})

            error && console.log(error)
            setProfile(data[0])
        }
        if (user) {
            getProfile()
        }
  
    },[user])



return (
    <div className={`bg-slate-200/50 ${subPage === 2 ? "h-screen" : "h-full" } pb-48 overflow-hidden`}>
            <div className="blur-3xl  ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-400" />

            <div className="relative " id="bookDemo">
                <h2 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                    Onboarding
                </h2>
                <div className="w-full lg:w-1/2 mx-auto px-20 lg:px-0 mt-10 sm:mt-12" id="waitlist">
                            {subPage === 0 &&
                
                                    <div className="sm:flex">
                                        <div className="min-w-0 flex-1 space-y-6">
                                        <div>
                                            <p className="text-slate-600 mb-2">Profile Pic </p>
                                    {picLoading ?
                                        <div className="flex justify-center">
                                            <svg className="animate-spin h-10 w-10 my- text-zinc-900 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                        </div>
                                        :
                                        <div

                                        >
                                            {(profile?.user_image) ?
                                                <div className="flex mb-4 justify-between items-center  w-full">

                                                    <Image
                                                        className={"rounded-full"}
                                                        src={`${cloudfront}/${profile.user_image}`}
                                                        width={80} height={80}
                                                        alt={profile.name}
                                                        objectFit="cover"
                                                    />
                                                    <div className=''>
                                                        <label
                                                            htmlFor="uploadProfile"
                                                            className=' py-2 px-4 mb-5 w-56 text-xs rounded-md  bg-slate-100 hover:bg-slate-200   font-medium  '
                                                        >
                                                            Change Image
                                                        </label>

                                                        <input
                                                            onChange={(e) => uploadImage(e, "user_image")}
                                                            type="file"
                                                            id="uploadProfile"
                                                            className='hidden py-2 px-4 mb-5 text-xs rounded-md border-2 bg-white border-fuchsia-700  shadow-lg   font-medium  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900' />
                                                    </div>
                                                </div>
                                                :
                                                <div className="flex justify-between items-center w-full">

                                                    <div className=' group'>

                                                        <input
                                                            onChange={(e) => uploadImage(e, "user_image")}
                                                            type="file"
                                                            placeholder='Upload Image'
                                                            className=' py-2 px-4 mb-5 w-56 text-xs rounded-md  bg-slate-200    font-medium  ' />
                                                    </div>
                                                </div>


                                            }
                                        </div>
                                    }
                                       
                                            </div>

                                            <div>
                                            <p className="text-slate-600 mb-2">Enter Education </p>
                                            <input
                                                name="education"
                                                defaultValue={listing.name}
                                                onChange={handleChange}
                                             
                                                className="block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700"
                                            />
                                            </div>
                                            <div>
                                            <p className="text-slate-600 mb-2">Pitch your coaching to potential clients. (2 - 5 sentences) </p>
                                            <textarea
                                                name="pitch"
                                                defaultValue={listing.email}
                                                onChange={handleChange}
                                              
                                                className="block text-sm w-full px-4 py-3 rounded-md border-0  text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700"
                                            />
                                            </div>
                                            <div>

                                             <p className="text-slate-600 mb-2">What is your coaching niche? (Helping physicians with burnout, How to market your own physician practice) </p>
                                            <textarea
                                                name="niche"
                                                defaultValue={listing.type}
                                                onChange={handleChange}
                                               
                                                className="block w-full px-4 py-3 rounded-md border-0 text-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700"
                                            />
                                            </div>
                                            <div>
                                                <p className="text-slate-600 mb-2">Additional background information to improve profile </p>
                                            <textarea
                                                name="info"
                                                defaultValue={listing.notes}
                                                onChange={handleChange}
                                               
                                                className="block w-full px-4 py-3 rounded-md border-0 text-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700"
                                            />
                                            </div>
                                            {error && 
                                                <p className='text-red-600'>{error}</p>
                                            }
                                        </div>

                                    </div>
                                    }
                     
                                    {subPage === 1 && 
                                            <div>
                                                <h3 className="text-slate-800 font-semibold">Pricing Model</h3>
                                                <p className="mb-4">How would you like to offer your services on the marketplace?</p>
                                                <div className="space-y-3">
                                                <button onClick={() => setSelected("per-lead")} className={`${selected ==="per-lead" && "border-fuchsia-500 border-2"} text-left rounded-lg hover:bg-slate-100 bg-white p-5 text-slate-700`}>
                                                    <p>Per Lead Pricing</p>
                                                    <p>$30*</p>
                                                    <p> <span className="font-bold ">How it Works:</span> Potential clients can send you a message to inquire about your services. 
                                                    You are charged if you would like to respond to an inquiry.  Spam messages are not counted as a billable event.</p>
                                                </button>
                                                <button onClick={() => setSelected("per-discovery-call")} className={`${selected ==="per-discovery-call" && "border-fuchsia-500 border-2"} text-left rounded-lg hover:bg-slate-100 bg-white p-5 text-slate-700`}>
                                                    <p>Per Discovery Call Pricing</p>
                                                    <p>$50*</p>
                                                    <p> <span className="font-bold ">How it Works:</span> Host only your discovery call on Plaza&apos;s video platform.  You are only charged if a potential
                                                    client shows up and joins your video call.</p>
                                                </button>
                                                <button onClick={() => setSelected("percentage")} className={`${selected ==="percentage" && "border-fuchsia-500 border-2"} text-left  rounded-lg hover:bg-slate-100 bg-white p-5 text-slate-700`}>
                                                    <p>Percentage of Coaching Package</p>
                                                    <p>10%</p>
                                                    <p> <span className="font-bold ">How it Works:</span> Host your entire coaching package on Plaza&apos;s all-in-one coaching platform where the only
                                                    charge is a percentage of your coaching package. With this option, you only pay a fee if a client signs up for your services</p>

                                                </button>
                                                <p className="text-slate-700">*starting prices for new coaches</p>
                                                </div>

                                            </div>
                                       
                            }
                               {subPage === 2 &&
                               <div className="space-y-6">
                                    <div>
                                        <p className="text-slate-600 mb-2">Estimated Monthly Cost: </p>
                                        <p className="text-slate-800 text-xl font-bold">$ { billing.monthly_lead_limit * (selected === "per-lead" ? 30 : 50 )}</p>
                                        <p className="text-slate-600 mb-2">*Note: Before being charged, we&apos;ll check-in with you to make sure you are satisfied with the quality
                                        of your {selected === "per-lead" ? "leads" : "discovery calls"}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-slate-600 mb-2">Monthly {selected === "per-lead" ? "Lead" : "Discovery Call"} Limit </p>
                                        <input
                                                name="monthly_lead_limit"
                                                defaultValue={billing.monthly_lead_limit}
                                                onChange={handleBillingChange}
                                                type="number"
                                                className="block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700 "
                                            />

                                    </div>
                   
                                </div>
                               }
                
       
                

                            <div className="mt-6">
                            <button
                                
                                onClick={next}
                                className="block w-full py-3 px-4 rounded-md hover:text-gray-900 shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900"
                            >
                                {loading ? <div className="flex justify-center">
                                    <svg className="animate-spin h-5 w-5 my-auto text-zinc-100 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </div> : "Next"}
                            </button>
                            </div>

                        </div>


            </div>
      


            </div>
)
}


const alertOptions = {
    // you can also just use 'bottom right'
    position: positions.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: { 'zIndex': '9999' },
    // you can also just use 'fade'
    transition: transitions.FADE,
}


Onboarding.getLayout = function getLayout(page) {
    return (
        <AlertProvider template={AlertTemplate} {...alertOptions}>
            <AuthProvider>
                <Layout>
                    {page}
                </Layout>
            </AuthProvider>
        </AlertProvider>
    )
}